<div>
  <div [ngClass]="!readOnly ? 'kt-padding-top-25' : 'read-only-tags'">
    <mat-form-field class="example-chip-list example-full-width" [appearance]="appearance">
      <mat-chip-list #chipList aria-label="Affiliations">
        <mat-chip
          cdkTextareaAutosize
          cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="3"
          *ngFor="let affiliation of affiliationList"
          [selectable]="selectable"
          [removable]="removable"
          (removed)="remove(affiliation)"
          [disabled]="readOnly"
        >
          {{ getAffiliationDescription(affiliation) }}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip>
      </mat-chip-list>
      <mat-label> Affiliations </mat-label>

      <input
        *ngIf="!this.readOnly"
        #affiliationInput
        (ngModelChange)="affiliationInputChanged($event)"
        [(ngModel)]="affiliationValue"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="false"
        (matChipInputTokenEnd)="add($event)"
      />

      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let affiliation of filteredAffiliations | async" [value]="affiliation">
          <span>{{ getAffiliationDescription(affiliation) }}</span>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
</div>
